import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionsChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 6.8125L6.625 1.1875L12.25 6.8125",
		stroke: "#222222",
		strokeWidth: 1.875,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgQuestionsChevron;
